<template>
	<div id="LoginAplication">
		<h3 class="text-center mt-5" v-if="showErrorMessage">
			{{ errorMessage }}
		</h3>
		<div v-else
			class="text-center d-flex vh-100 align-items-center justify-content-center">
			<div>
				<h3>
					{{ randomPhrase() }}
				</h3>
				<i class="fas fa-spinner fa-spin fa-2x mt-4 mt-md-5"></i>
			</div>
		</div>
	</div>
</template>

<script>
	import apiMixins from "@/mixins/apiMixins";
	export default {
		name: "LoginAplication",
		data() {
			return {
				token: "",
				postId: "",
				showErrorMessage: false,
				errorMessage: "",
			};
		},
		mixins: [apiMixins],
		beforeCreate() {
			localStorage.clear();
		},
		created() {
			// Obtém o token de acesso, se não houver,redireciona pra login
			if (this.$route.query.token) {
				this.token = this.$route.query.token;
			} else {
				this.redirectToLogin();
			}
			if (this.$route.query.postid) {
				this.postId = this.$route.query.postid;
			}
		},
		async mounted() {
			// Valida o token de acesso
			const userDataFromToken = await this.validateToken();
			if (userDataFromToken.status != 1) {
				this.redirectToLogin();
			}

			// Inicia a sessão
			this.$session.start();
			
			// Salva os dados de acesso em localStorage
			this.saveDataInLocalStorage(userDataFromToken);

			// Grava os dados do acesso em sessão
			await this.saveDataInSession(userDataFromToken);

			// Aplica as cores da franquia nas classes do painel
			this.tintPanel();

			// Se a conta possui site, valida e utiliza seus dados
			if (userDataFromToken.sites.length > 0) {
				let site = userDataFromToken.sites[0];

				this.$store.dispatch("VERIFY_TOKEN");
				this.$store.dispatch("VERIFY_SITE");
				this.$session.set("welcome", site.welcome);
				this.$session.set("animationMenu", site.welcome);

				localStorage.setItem("siteId", site.id);
				localStorage.setItem("siteData", JSON.stringify(site));

				// Se wizard foi feito, busca as imagens do site e redirecina para o painel
				if (site.wizard == 1) {
					this.$store.dispatch("userModule/GET_USER_MEDIAS", [this.$session.get('jwt'), site.id]);
					this.$session.set("wizard", 1);
					// Se o acesso está vindo com um id de post, já abre o painel com esse post em edição
					if (this.postId) {
						this.goPostEditor(site.id, this.postId);
					} else {
						this.goDashboard(site.id);
					}
				} else {
					this.$session.set("wizard", 0);
					this.goWizard(site.id);
				}
			}
			// Se não, requisita a criação de um novo site e abre o wizard dele 
			else {
				let site = await this.createSite();
				this.$store.dispatch("VERIFY_TOKEN");
				this.$session.set("welcome", true);
				this.goWizard(site.siteId);
			}
			//Salva a sessão vinda da landing no localStorage
			// this.getSessionFromURL();
		},
		methods: {
			async validateToken() {
				let url = "/application/user/login/validate";
				let data = {
					token: this.token,
				};
				let responseApiData = await this.validateTokenRequest(url, data);
				return responseApiData;
			},
			saveDataInLocalStorage(response){
				localStorage.setItem("financial", response.application.financial ?? 1);
				localStorage.setItem("themeColor", response.application.main_color);
				localStorage.setItem("backgroundColor", response.application.background_color);
				localStorage.setItem("jwt", response.token);
				localStorage.setItem("ogImage", response.application.og_image);
				localStorage.setItem("ogDescription", response.application.og_description);
				localStorage.setItem("appleIcon", response.application.apple_icon);
				localStorage.setItem("showAffiliate", response.application.show_affiliate);
				localStorage.setItem("panelUrl", response.panelUrl);
			},
			tintPanel(){
				document.documentElement.style.setProperty("--main-color", localStorage.getItem("themeColor"));
				document.documentElement.style.setProperty("--bg-color",localStorage.getItem("backgroundColor"));
			},
			
			saveDataInSession(response){
				this.$session.set("jwt", response.token);
				this.$session.set("userEmail", response.email);
				this.$session.set("appKey", response.application.app_key);
				this.$session.set("appBaseDomain",response.application.app_base_domain);
				this.$session.set("appBaseDomain", response.application.app_base_domain);
				this.$session.set("appDefaultIdd", response.application.default_idd);
				return true;
			},
			redirectToLogin() {
				let url = window.location.hostname;
				if (url != "localhost") {
					url = url.replace("painel.", "");

					if (url == 'epics.vc') {
						url = 'https://www.epics.com.br/dashboard';
					} else {
						url = `https://${url}/login`;
					}

					window.open(url, "_self");
				} else {
					alert("erro no token");
				}
			},
			goWizard,
			goDashboard,
			goPostEditor(siteId, postId) {
				this.$session.set("siteId", siteId);
				this.$router.push({
					name: "PostEditor",
					params: { postId: postId },
				});
			},
			createSite,
			getSessionFromURL,
			randomPhrase() {
				let phrases = ["Acessando o painel do site"];

				let rand = Math.floor(Math.random() * phrases.length);

				return phrases[0];
			},
		},
	};
	function getSessionFromURL() {
		localStorage.setItem("landing_session", this.$route.query.session);
	}

	async function createSite() {
		let totalData = "";
		let token = this.$session.get("jwt");
		let url = `/site/create`;

		let site = await this.requestApiData(url, "get", totalData);

		return site;
	}
	function goWizard(site) {
		this.$session.set("siteId", site);
		this.$router.push({
			name: "StepWizard",
			params: { stepWizard: 'StepWizardIntegrations' },
		});
	}
	function goDashboard(site) {
		this.$session.set("siteId", site);
		this.$router.push("/dashboard");
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/templates/LoginApplication.vue